import React, { useState } from "react";
import { IoHeart, IoHeartOutline } from "react-icons/io5";
import { IconContext } from "react-icons";

export enum EListingFavoriteBackgroundShape {
  none = "none",
  circle = "circle",
  square = "square",
  triangle = "triangle",
}

export interface IListingFavoriteProps {
  selected: boolean;
  toggleFunction: Function;
  className?: string;
  position?: [boolean, boolean];
  backgroundShape?: EListingFavoriteBackgroundShape;
}

export const ListingFavorite: React.FC<IListingFavoriteProps> = ({
  selected,
  toggleFunction,
  className,
  position = [false, false],
  backgroundShape = EListingFavoriteBackgroundShape.none,
}) => {
  const [selectedState, setSelectedState] = useState(selected);
  const handleToggle = () => {
    setSelectedState(!selectedState);
    toggleFunction(selectedState);
  };

  let layoutVariant = `${position[0] ? "top-0" : "top-2"} 
      ${position[1] ? "right-0" : "right-2"}`;

  switch (backgroundShape) {
    case EListingFavoriteBackgroundShape.triangle:
      layoutVariant =
        "top-0 right-0 z-0 before:content-[''] before:absolute before:z-[-1] before:top-0 before:right-0 before:border-t-[70px] before:border-t-action before:border-l-[70px] before:border-l-transparent";
      break;
    case EListingFavoriteBackgroundShape.circle:
      layoutVariant = "top-2 right-2 bg-action rounded-full";
      break;
    case EListingFavoriteBackgroundShape.square:
      layoutVariant += " bg-action";
      break;
    case EListingFavoriteBackgroundShape.none:
      layoutVariant += " drop-shadow-lg text-2xl";
      break;
  }

  return (
    <IconContext.Provider value={{ size: "1.5em", className: "inline" }}>
      <div className={`p-2 text-action-text ${layoutVariant} ${className}`}>
        <button onClick={handleToggle}>
          {selectedState ? (
            <>
              <IoHeart />
              <span className="sr-only">Add listing to favorites.</span>
            </>
          ) : (
            <>
              <IoHeartOutline />
              <span className="sr-only">Remove listing from favorites.</span>
            </>
          )}
        </button>
      </div>
    </IconContext.Provider>
  );
};
